var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home page"},[_c('img',{attrs:{"alt":"Logo","src":"/images/logo-120.png"}}),_c('h1',[_vm._v("NoNought")]),_c('blockquote',[_vm._v("Never have a 0% day!")]),_c('SignIn')],1)}
var staticRenderFns = []

export { render, staticRenderFns }